/**
 * Group GA dashboard cards into folders / unfiled / archived.
 * Order inside each bucket follows the incoming list (personal order).
 */

export function isArchivedDashboard(d) {
  return Boolean(d?.archived_at);
}

export function companionId(specialKey) {
  return `special:${specialKey}`;
}

export function isCompanionId(id) {
  return String(id || '').startsWith('special:');
}

export function companionKeyFromId(id) {
  return String(id || '').replace(/^special:/, '');
}

export function groupDashboards(dashboards = [], folders = [], companions = []) {
  const items = [
    ...companions.map((c) => ({
      ...c,
      id: companionId(c.specialKey),
      isSpecial: true,
    })),
    ...dashboards,
  ];
  const live = [];
  const archived = [];
  for (const d of items) {
    if (isArchivedDashboard(d)) archived.push(d);
    else live.push(d);
  }

  const byFolder = new Map();
  for (const f of folders) byFolder.set(Number(f.id), []);

  const unfiled = [];
  for (const d of live) {
    const fid = d.folder_id == null || d.folder_id === '' ? null : Number(d.folder_id);
    if (fid && byFolder.has(fid)) byFolder.get(fid).push(d);
    else unfiled.push(d);
  }

  return {
    folderGroups: folders.map((folder) => ({
      folder,
      dashboards: byFolder.get(Number(folder.id)) || [],
    })),
    unfiled,
    archived,
  };
}

export function collapseStorageKey(jobNumber) {
  return `ga-dashboard-collapsed-${jobNumber}`;
}

export function loadCollapsed(jobNumber) {
  if (!jobNumber) return { archive: true };
  try {
    const parsed = JSON.parse(localStorage.getItem(collapseStorageKey(jobNumber)) || '{}');
    return { archive: true, ...(parsed && typeof parsed === 'object' ? parsed : {}) };
  } catch {
    return { archive: true };
  }
}

export function saveCollapsed(jobNumber, next) {
  if (!jobNumber) return;
  try { localStorage.setItem(collapseStorageKey(jobNumber), JSON.stringify(next)); } catch { /* private mode */ }
}
